module IS.Localization {
    angular.module('localization', [])
        .run(['localizeService', (localizeService: LocalizeService) => {
            localizeService.initializeLocalizedResources();
        }]);
}